import { EventEmitter, Injectable } from '@angular/core';
import {
  AsyncValidatorFn,
  AbstractControl,
  ValidationErrors,
  NonNullableFormBuilder,
} from '@angular/forms';
import { Observable, map, of, catchError, Subject, switchMap } from 'rxjs';
import { BaseFpxDataService } from '../../models/data-service.model';
import { TNavigation } from '../../models/forms.model';
import { SpinnerService } from '../spinner/spinner.service';

@Injectable({
  providedIn: 'root',
})
export class ValidatorService {
  constructor(private _spinnerService : SpinnerService) {}

  dataAvailabilityCheck(
    mode: TNavigation,
    controlName: string,
    service: BaseFpxDataService<unknown>,
    subject: Subject<unknown>
  ): AsyncValidatorFn {
    console.log('Inside data availability check method');
    return (
      control: AbstractControl
    ):
      | Promise<ValidationErrors | null>
      | Observable<ValidationErrors | null> => {
        this._spinnerService.show();
      const key = control.parent?.value || {};

      if (service.findByKey && control.value) {
        key[controlName] = control.value;
        return of(key).pipe(
          switchMap(() =>
            service
              .findByKey(key)()
              .pipe(
                map(
                  (res: any) => {
                    if (mode === 'MODIFY' && !res) {
                      subject.next(null);
                      this._spinnerService.hide();
                      return { data_not_available: true };
                    } else if (mode === 'ADD' && res) {
                      subject.next(null);
                      this._spinnerService.hide();
                      return { data_already_available: true };
                    }
                    subject.next(res);
                    this._spinnerService.hide();
                    return null;
                  },
                  catchError(() => {
                    subject.next(null);
                    this._spinnerService.hide();
                    return of({ network_down: true });
                  })
                )
              )
          )
        );
      } else {
        return of();
      }
    };
  }
}
